<div class="flex flex-col gap-8">
  <p>turns-statistics works!</p>
  <p-card header="Filtros">
    <ng-template pTemplate="content">
      <p>This is the content of the card.</p>
      <form [formGroup]="formGroup">
        <div >
          <div class="">
            <div>
              <p-calendar
                formControlName="date"
                selectionMode="range"
                placeholder="Seleccione un rango de fechas"
                (onSelect)="onSelectDate($event)"
              ></p-calendar>
            </div>
            <div>
              <p-dropdown
                formControlName="selectedCity"
                [options]="cities"
                optionLabel="name"
                [filter]="true"
                filterBy="name"
                [showClear]="true"
                placeholder="Select a City"
              />
            </div>
          </div>
          <div>
            <p-button label="Aplicar Filtros" />
          </div>
        </div>
      </form>
    </ng-template>
  </p-card>
</div>
